export default "__VITE_ASSET__a056c49e__"